module.exports = __webpack_public_path__ + "static/img/five.0a4f0f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/five.png
// module id = RHtX
// module chunks = 0